import { render, staticRenderFns } from "./InfoMessageNew.vue?vue&type=template&id=0217d1f0&scoped=true&"
import script from "./InfoMessageNew.vue?vue&type=script&lang=js&"
export * from "./InfoMessageNew.vue?vue&type=script&lang=js&"
import style0 from "./InfoMessageNew.vue?vue&type=style&index=0&id=0217d1f0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0217d1f0",
  null
  
)

export default component.exports